import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as ExcelJS from 'exceljs';

@Injectable()
export class ExcelService {
  errorMessage: string;

  async exportAsExcelFile(json: any[], excelFileName: string, date: string, time: string): Promise<void> {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('data');

      if (json.length > 0) {
        worksheet.columns = Object.keys(json[0]).map((key) => ({ header: key, key }));
        worksheet.addRows(json);
      }

      const buffer = await workbook.xlsx.writeBuffer();
      this.saveAsExcelFile(buffer, excelFileName, date, time);
    } catch (e) {
      this.errorMessage = 'Could not export xlsx file';
    }
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string, date: string, time: string): void {
    const type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const data: Blob = new Blob([buffer], { type });
    FileSaver.saveAs(data, `${fileName}${date}_${time}.xlsx`);
  }
}
